// extracted by mini-css-extract-plugin
export default {"placeholder":"xZik0gXZraA1rj_eU0ow","screener-ordinal":"C3qb3ggPyWRFpWYgkyFj","screenerOrdinal":"C3qb3ggPyWRFpWYgkyFj","add":"Y093ipFTmYwAcxTz_Vku"};